export class BemService {
  static getElement(block: string, element: string): string {
    return `${block}__${element}`;
  }
}
